import ShippingLabelGenerationError from './ShippingLabelGenerationError';

export default ShippingLabelGenerationError;
